import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  showAddTicketPopup,
  showTicketDetailsPopup,
  hideTicketDetailsPopup,
  setTickets,
  hideAddTicketPopup,
} from "../../Pages/Store";
import AddTicket from "./AddTicket";
import TicketDetails from "./TicketDetails";
import { useNavigate, Link } from "react-router-dom";
import { statusColors } from "../../Pages/Config";
import { getAllTickets, getErrorMessage } from "../../services/api";
import "../../Styles/SelfService.css";
// import { FiLogOut } from "react-icons/fi";
import { toast } from "react-toastify";
import useIdleTimer from "../../Pages/UseIdleTimer";
import Avatar from "@mui/material/Avatar";
import {
  Divider,
  Menu,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import UserPng from "../../Assets/user-icon.png";
import logoDark from "../../Assets/logo-dark.svg";


const SelfService = () => {
  const navigate = useNavigate();
  const [ticketNumber, setTicketNumber] = useState("");
  const [sortValue, setSortValue] = useState("All");
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [dataBase, setDataBase] = useState([]);
  const tickets = useSelector((state) => state.root.tickets);
  const dispatch = useDispatch();
  const {
    showAddTicketPopup: showAddTicket,
    showTicketDetailsPopup: showTicketDetails,
    ticketDetails,
    userData,
  } = useSelector((state) => state.root);
  const login = localStorage.getItem("Login");

  const handleLogout = () => {
    navigate("/");
    localStorage.removeItem("Login");
    localStorage.removeItem("ssCreds");
    localStorage.removeItem("sessionId");
  };

  const handleMyAccount = () => {
    navigate("/my-account");
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  //string avatar image

  const userName = localStorage.getItem("name") || "User";
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useIdleTimer(handleLogout, 900000);

  useEffect(() => {
    const login = localStorage.getItem("Login");
    const isadmin = localStorage.getItem("isadmin");
    // console.log('login-',login);

    if (!login) {
      handleLogout();
    }
  }, [login]);

  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useIdleTimer(handleLogout, 900000);

  useEffect(() => {
    if (!login) {
      handleLogout();
    }
  }, [login]);

  useEffect(() => {
    if (totalTickets === 0) {
      handleData();
    }
    dispatch(hideTicketDetailsPopup());
    dispatch(hideAddTicketPopup());
    getKnowledgeBase();
  }, []);

  const handleTicketType = (event) => {
    const ticketType = event.target.value; // Capture the selected ticket type
    console.log("Selected Ticket Type:", ticketType);
    dispatch(showAddTicketPopup(ticketType)); // Pass it to the action
  };

  const getKnowledgeBase = async () => {
    try {
      const response = await fetch(
        "https://ns.frothcrm.com/bookstack/public/api/pages",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Token 8ZCNXgGDcOxH29fbGd7OhjymvLmXL9iX:ThPd1IaXaQNKYmJ0QZPxX4nejigxtNOG",
          },
        }
      );

      if (!response.ok) {
        toast.warn("Something went wrong!", {
          position: "top-right",
          autoClose: 2000,
        });
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      setDataBase(data?.data);
    } catch (error) {
      console.error("Failed to fetch books:", error);
    }
  };

  const handleData = async () => {
    setLoading(true);
    try {
      const { username, password } = JSON.parse(
        localStorage.getItem("ssCreds") || "{}"
      );
      const response = await getAllTickets(username, password);
      dispatch(setTickets(response.data.tickets));
    } catch (error) {
      dispatch(setTickets([]));
      toast.error(getErrorMessage(error, "Failed to load tickets"), {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSortChange({ target: { value: sortValue } });
  }, [tickets]);

  useEffect(() => {
    paginateTickets();
  }, [filteredTickets, currentPage, pageSize]);

  const handleSortChange = (event) => {
    const selectedValue = event.target.value;
    setSortValue(selectedValue);

    if (selectedValue === "All") {
      setFilteredTickets(tickets);
    } else {
      const filteredData = tickets.filter(
        (ticket) => ticket.status === selectedValue
      );
      setFilteredTickets(filteredData);
    }
    setCurrentPage(1);
  };

  const searchTicket = () => {
    if (ticketNumber.trim()) {
      const searchTicket = tickets.find(
        (ticket) => String(ticket.caseNumber) === ticketNumber.trim()
      );

      if (searchTicket) {
        dispatch(showTicketDetailsPopup(searchTicket));
      } else {
        toast.warn("Ticket not found", {
          position: "top-right",
          autoClose: 2000,
        });
      }
      setTicketNumber("");
    } else {
      toast.warn("Enter case number to search", {
        position: "top-right",
        autoClose: 2000,
      });
    }
  };

  const totalTickets = tickets?.length || 0;
  const openTickets = tickets?.length !==0 ? tickets?.filter((ticket) =>
    ticket.status.includes("Open") || ticket.status.includes("New")
  ).length: 0;

  // Extract unique status values from tickets for dynamic dropdown
  const uniqueStatuses = React.useMemo(() => {
    if (!tickets || tickets.length === 0) return [];
    const statuses = new Set(tickets.map(ticket => ticket.status).filter(Boolean));
    return Array.from(statuses).sort(); // Sort alphabetically
  }, [tickets]);

  const paginateTickets = () => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const sortedTickets = filteredTickets.sort((a, b) => {
      // Sort by createdOn date (newest first)
      const dateA = new Date(a.createdOn || 0);
      const dateB = new Date(b.createdOn || 0);
      return dateB - dateA; // Descending order (newest first)
    });
    return sortedTickets.slice(startIndex, endIndex);
  };

  const handleSearch = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      searchTicket();
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(filteredTickets.length / pageSize);

  const Pagination = ({ totalPages, currentPage, handlePageChange }) => {
    const pageNumbers = [];
  
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1, 2);
  
      if (currentPage > 6 && currentPage < totalPages - 2) {
        pageNumbers.push('...');
        pageNumbers.push(currentPage - 1, currentPage, currentPage + 1);
        pageNumbers.push('...');
      } else if (currentPage <= 3) {
        pageNumbers.push(3, 4);
        pageNumbers.push('...');
      } else {
        pageNumbers.push('...');
        pageNumbers.push(totalPages - 3, totalPages - 2);
      }
      pageNumbers.push(totalPages - 1, totalPages);
    }
  
    return (
      <nav>
        <ul className="pagination justify-content-center mt-3 mt-md-0">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>
          </li>
          {pageNumbers.map((number, index) => (
            <li
              key={index}
              className={`page-item ${number === currentPage ? "active" : ""}`}
            >
              {number === '...' ? (
                <span className="page-link">{number}</span>
              ) : (
                <button
                  className="page-link"
                  onClick={() => handlePageChange(number)}
                >
                  {number}
                </button>
              )}
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &raquo;
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  const openInNewTab = (content) => {
    const newWindow = window.open();
    newWindow.document.open();
    newWindow.document.write(content);
    newWindow.document.close();
  };

  const showContent = async (name, id) => {
    try {
      const response = await fetch(
        `https://ns.frothcrm.com/bookstack/public/api/pages/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Token 8ZCNXgGDcOxH29fbGd7OhjymvLmXL9iX:ThPd1IaXaQNKYmJ0QZPxX4nejigxtNOG",
          },
        }
      );

      if (!response.ok) {
        toast.warn("Something went wrong!", {
          position: "top-right",
          autoClose: 2000,
        });
        throw new Error(`Error: ${response.status}`);
      }
      const dataBook = await response.json();
      const content = `
      <html>
      <head>
      <link rel="icon" href="data:image/svg+xml,<svg xmlns=%22
http://www.w3.org/2000/svg%22
viewBox=%220 0 36 36%22><text y=%2232%22 font-size=%2232%22>🌍</text></svg>" />
        <title>${name}</title>
      </head>
      <body>
              ${dataBook?.html}
      </body>
      </html>
    `;
      openInNewTab(content);
    } catch (error) {
      toast.warn("Failed to fetch books!", {
        position: "top-right",
        autoClose: 2000,
      });
      console.error("Failed to fetch books:", error);
    }
  };

  return (
    <div className="container-fluid ss-page">
              <div className="row breadcrumb-contain ss-topbar">
        <div className="col-xl-6 col-lg-6 col-md-8 col-sm-8 col-8 breadcrumb-nav">
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              className="breadcrumb-home"
              underline="hover"
              color="inherit"
            >
              <img src={logoDark} alt="Self Service" className="breadcrumb-logo" />
            </Link>
          </Breadcrumbs>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-4 col-sm-4 col-4 nav-profile ">
          <div
            className={`profile-trigger ${Boolean(anchorEl) ? "profile-trigger-open" : ""}`}
            onClick={handleMenu}
          >
            <Avatar src={UserPng} className="profile-avatar" />
            <span className="profile-trigger-name">
              {(localStorage.getItem("name") || "Account").split(" ")[0]}
            </span>
            <KeyboardArrowDownIcon className="profile-trigger-caret" fontSize="small" />
          </div>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            slotProps={{
              paper: {
                sx: {
                  mt: 1.25,
                  minWidth: 240,
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 16px 40px rgba(15,23,42,0.16)",
                  overflow: "hidden",
                },
              },
            }}
          >
            <div className="profile-menu-compact">
              <div className="profile-menu-name">
                <PersonIcon fontSize="small" className="profile-menu-row-icon" />
                {localStorage.getItem("name")}
              </div>
              <div className="profile-menu-email">
                <EmailIcon fontSize="small" className="profile-menu-row-icon" />
                {localStorage.getItem("email")}
              </div>
            </div>
            <Divider />
            <MenuItem onClick={handleLogout} className="profile-menu-logout-compact">
              <LogoutIcon fontSize="small" className="profile-menu-logout-icon" />
              Logout
            </MenuItem>
          </Menu>
        </div>
      </div>

      <div className="ss-toolbar-card">
        <div className="row ticket-table-nav">
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 ticket-count">
            <div className="total-ticket stat-chip">
              <b>Total Tickets: {totalTickets}</b>
            </div>
            <div className="open-ticket stat-chip stat-chip-open">
              <b>Open Tickets: {openTickets}</b>
            </div>
          </div>
          <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 ticket-buttons">
            <div className="search-input">
              <input
                type="text"
                className="form-control mb-2 mb-md-0 me-md-0"
                id="ticketNumber"
                placeholder="Search Case Number"
                value={ticketNumber}
                onKeyDown={handleSearch}
                onChange={(e) => setTicketNumber(e.target.value)}
              />
              <button type="button" onClick={searchTicket}>
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>

            <div className="new-ticket" style={{ width: "auto" }}>
            <div className="select-with-icon select-with-icon-primary">
              <AddCircleOutlineIcon fontSize="small" className="select-icon" />
              <Select
                className="ss-mui-select ss-mui-select-primary"
                id="createTicketTypeSelect"
                onChange={handleTicketType}
                title="Create a new ticket"
                value="All"
                variant="outlined"
                size="small"
                MenuProps={{ slotProps: { paper: { className: "ss-select-menu-paper" } } }}
              >
                <MenuItem value="All"> New Ticket</MenuItem>
                <MenuItem value="Incident">Incident</MenuItem>
                <MenuItem value="Service Request">Service Request</MenuItem>
                <MenuItem value="Change Request">Change Request</MenuItem>
              </Select>
              </div>

              {/* <button
                type="button"
                className="btn btn-light mb-2 mb-md-0 me-2 add-btn"
                onClick={() => dispatch(showAddTicketPopup())}
                style={{ width: "8.9rem" }}
              >
                <AddCircleOutlineIcon fontSize="small" /> New Ticket
              </button> */}
            </div>
            <div
              className="form-group mb-2 mb-md-0 filter-btn"
              style={{ width: "auto" }}
            >
              <div className="select-with-icon">
                <FilterListIcon fontSize="small" className="select-icon" />
                <Select
                  className="ss-mui-select"
                  id="sortSelect"
                  onChange={handleSortChange}
                  title="Filter by Status"
                  value={sortValue}
                  variant="outlined"
                  size="small"
                  MenuProps={{ slotProps: { paper: { className: "ss-select-menu-paper" } } }}
                >
                  <MenuItem value="All">All</MenuItem>
                  {uniqueStatuses.map((status) => (
                    <MenuItem key={status} value={status}>
                      <span
                        className="status-dot-inline"
                        style={{ background: statusColors[status] || statusColors.Default }}
                      ></span>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>

            <button
              type="button"
              className="btn btn-ss-primary mb-2 mb-md-0 me-2"
              onClick={() => {
                const customerId = tickets?.[0]?.customer_id;
                if (customerId) {
                  navigate(`/Self-Service/Company-Tickets/${customerId}`);
                } else {
                  toast.warn("Customer ID not found. Please ensure you have tickets loaded.", {
                    position: "top-right",
                    autoClose: 3000,
                  });
                }
              }}
            >
              Company Tickets
            </button>

          </div>
        </div>
      </div>
        {/* <div className="row">
          <div className="d-flex justify-content-between align-items-center">
            <div className="col-md-6 d-flex flex-wrap align-items-center">
              <div className="me-3 mb-2 mb-md-0">
                <b>Name:</b> {localStorage.getItem("name")}
              </div>
              <div className="mb-2 mb-md-0">
                <b>Email:</b> {localStorage.getItem("email")}
              </div>
            </div>
            <button className="col-md-1 btn btn-light add-btn" onClick={handleLogout} style={{ textWrap: "nowrap" }}>
              Logout
            </button>
          </div>
        </div>
        <div className="row mb-4 mt-3">
          <form className="d-flex flex-column flex-md-row align-items-center justify-content-between">
            <div className="d-flex flex-column flex-md-row align-items-center mb-3 mb-md-0">
              <input
                type="text"
                className="col-md-4 form-control mb-2 mb-md-0 me-md-2"
                id="ticketNumber"
                placeholder="Enter case number..."
                value={ticketNumber}
                onKeyDown={handleSearch}
                onChange={(e) => setTicketNumber(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-light mb-2 mb-md-0 me-2 add-btn"
                onClick={searchTicket}
                style={{ width: "7.5rem" }}
              >
                Search
              </button>
              <button
                type="button"
                className="btn btn-light mb-2 mb-md-0 me-2 add-btn"
                onClick={() => dispatch(showAddTicketPopup())}
                style={{ width: "7.5rem" }}
              >
                + New Ticket
              </button>
              <div className="form-group mb-2 mb-md-0"  style={{ width: "7.5rem" }}>
                <select
                  className="form-select"
                  id="sortSelect"
                  onChange={handleSortChange}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Filter by Status"
                  value={sortValue}
                >
                  <option value="All">All</option>
                  <option value="Assigned">Assigned</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Closed">Closed</option>
                  <option value="New">New</option>
                  <option value="Pending">Pending</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Resolved">Resolved</option>
                  <option value="Duplicate">Duplicate</option>
                </select>
              </div>
            </div>
            <div className="d-flex flex-column flex-md-row align-items-center">
              <div className="ms-0 ms-md-3 mb-2 mb-md-0">
                <b>Total Tickets:</b> {totalTickets}
              </div>
              <div className="ms-0 ms-md-3">
                <b>Open Tickets:</b> {openTickets}
              </div>
            </div>
          </form>
        </div> */}
      <div className="ss-table-card">
      <div className="table-responsive">
        {!loading && (totalTickets === 0 || filteredTickets?.length === 0) ? (
          <div className="text-center">No tickets available</div>
        ) : (
          <>
            <table className="table table-bordered text-start">
              <thead style={{ textWrap: "nowrap" }}>
                <tr>
                  <th scope="col">SL NO</th>
                  <th scope="col">Case Number</th>
                  <th scope="col">Case Title</th>
                  <th scope="col">Ticket Type</th>
                  <th scope="col">Raised On</th>
                  <th scope="col">Assigned To</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {paginateTickets().map((ticket, index) => {
                  const statusColor =
                    statusColors[ticket.status] || statusColors.Default;

                  return (
                    <tr key={index}>
                      <td style={{ borderLeft: `4px solid ${statusColor}` }}>
                        {(currentPage - 1) * pageSize + index + 1}
                      </td>
                      <td>
                        <a
                          id="user-button"
                          onClick={() =>
                            dispatch(showTicketDetailsPopup(ticket))
                          }
                        >
                          {ticket.caseNumber}
                        </a>
                      </td>
                      <td>{ticket.title}</td>
                      <td>{ticket.ticketType}</td>
                      <td style={{ textWrap: "nowrap" }}>
                        {ticket.createdOn?.split(/[ T]/)[0]}
                      </td>
                      <td>{ticket.assignedTo || "-"}</td>
                      <td>
                            <span className="status-badge" style={{ "--status-badge-color": statusColor }}>
                            <span style={{ background: "rgba(255,255,255,0.85)" }} class="dot"></span>

                            <span>{ticket.status}</span>
                            </span>

                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div id="loadingSpinner" style={{ display: "none" }}>
              <i className="fa-solid fa-spinner fa-3x mx-auto d-block"></i>
            </div>
          </>
        )}
        {loading && (
          <div class="text-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
      </div>
      <div className="Pagination">
  <div className="ss-page-size">
    <span className="ss-page-size-label">Items per page</span>
    <Select
      className="ss-mui-select ss-mui-select-compact"
      value={pageSize}
      onChange={handlePageSizeChange}
      variant="outlined"
      size="small"
      slotProps={{ paper: { className: "ss-select-menu-paper" } }}
    >
      <MenuItem value={10}>10</MenuItem>
      <MenuItem value={20}>20</MenuItem>
      <MenuItem value={50}>50</MenuItem>
    </Select>
  </div>
  <Pagination
    totalPages={totalPages}
    currentPage={currentPage}
    handlePageChange={handlePageChange}
  />
</div>
      <div className="accordion" id="accordionExample" style={{ display: "none" }} >
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${isOpen ? "" : "collapsed"}`}
              type="button"
              onClick={toggleAccordion}
              aria-expanded={isOpen}
              aria-controls="collapseOne"
            >
              Knowledge Base
            </button>
          </h2>
          <div
            id="collapseOne"
            className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="container mt-4">
                <div className="row">
                  {dataBase && dataBase.length > 0 ? (
                    dataBase.map((item) => (
                      <div
                        className="col-12 col-md-4 mb-4 custom-col-width" 
                        key={item.id}
                        style={{
                          marginLeft: "2%",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="card"
                          title="Preview book"
                          onClick={() => {
                            showContent(item.name, item?.id);
                          }}
                          style={{ border: "none" }}
                        >
                          <div
                            className="card-body"
                            style={{ border: "none " }}
                          >
                            <h5 className="card-title">{item.name}</h5>
                            <p className="card-text">
                              Created At: {item.created_at?.split("T")[0]}
                            </p>
                            <p className="card-text">Slug: {item.slug}</p>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12">
                      <p>No data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAddTicket && <AddTicket />}
      {showTicketDetails && (
        <TicketDetails
          ticket={ticketDetails}
          onClose={() => dispatch(hideTicketDetailsPopup())}
        />
      )}
    </div>
  );
};

export default SelfService;
